import MyTraining from "src/pages/TrainingWorkshop/MyTraining";


export const myTrainingRoutes = [
    // my training
    { path: '/trainee/trainee-registration-worklist', component: MyTraining },    
];
